jQuery(document).ready(function($) {
//	$("#dateArrive").datepicker({dateFormat: "mm/dd/yy"});
//	$("#dateDepart").datepicker({dateFormat: "mm/dd/yy"});
});
function toggleNav(){
	var navSize = document.getElementById("bookingWidgetContainer").style.marginRight;
	if (navSize == "300px") {
        return closeNav();
    }
    return openNav();
}

function openNav() {
	document.getElementById("bookingWidgetContainer").style.marginRight = "300px";
	document.getElementById("bwArrow").style.transform = "rotate(-180deg)";
	document.getElementById("content").addEventListener("click", closeNav);
}

function closeNav() {
	document.getElementById("bookingWidgetContainer").style.marginRight = "0px";
	document.getElementById("bwArrow").style.transform = "rotate(0)";
	document.getElementById("content").removeEventListener("click", closeNav);
}
	
//function setDepart() {
//	var departDate = document.getElementById("dateDepart").value;
//	document.getElementById("dateOUT").value = departDate;
//}
//function setArrive() {
//	var arriveDate = document.getElementById("dateArrive").value;
//	document.getElementById("dateIN").value = arriveDate;
//}